import { render } from "./reputacionChart.vue?vue&type=template&id=652f25f6&scoped=true"
import script from "./reputacionChart.vue?vue&type=script&lang=js"
export * from "./reputacionChart.vue?vue&type=script&lang=js"

import "./reputacionChart.vue?vue&type=style&index=0&id=652f25f6&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652f25f6"]])

export default __exports__